import moment from 'moment';

export const parseFoSell = (foPool, message, content) => {
    
        foPool.lastUpdateTime = moment(window.ssTime + content.timeOffset * 1000).format("YYYY-MM-DDTHH:mm:ss+08:00");
    if ( message.id ) {
        foPool.poolId = message.id;
    }
    if (message.expStartSellTm) {
        foPool.expStartDateTime = message.expStartSellTm;
    }
    if (message.expStopSellTm) {
        foPool.expStopDateTime = message.expStopSellTm;
    }
    if (message.maxRaNoStoppedSell) {
        foPool.raceStopSellNo = message.maxRaNoStoppedSell.raNo ;
        foPool.raceStopSellStatus = message.maxRaNoStoppedSell.st.toString(); 
    }
    if (message.chlInfo) {
        foPool.sellStatus = message.chlInfo.filter(x=> x.chl === "InteractiveService")[0].st ;
        if(foPool.sellStatus != "Available" ){
            content.setFOSelectedBet({})
        }
    }
}